import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=a4bc6424&scoped=true&"
var script = {}
import style0 from "./Snackbar.vue?vue&type=style&index=0&id=a4bc6424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bc6424",
  null
  
)

export default component.exports